import { ShipmentAddress } from './shipment-address';
import { Address } from './address';
import { Pos } from './pos';

interface IExtractInfo {
  lab_id?: string;
  agent_id?: string;
  mshp_id?: string
}

export class Party {
  protected _extractInfo: IExtractInfo;

  constructor(
    private _entity: string = null,
    private _id: string = null,
    private _shipmentAddress: ShipmentAddress | undefined = null,
    private _name: string = null,
    private _address: Address = null,
    private _pos: Pos = null,
    private _iban: string = null,
  ) {
    this._extractInfo = {};
  }

  get entity(): string {
    return this._entity;
  }

  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  get shipmentAddress(): ShipmentAddress {
    return this._shipmentAddress;
  }

  get address(): Address {
    return this._address;
  }

  get pos(): Pos {
    return this._pos;
  }

  get iban(): string {
    return this._iban;
  }

  get fullAddress(): string {
    let fullAddress = this._shipmentAddress.address + ' ';
    fullAddress += this._shipmentAddress.addressLine2 ? this._shipmentAddress.addressLine2 : '';
    fullAddress += ', ' + this._shipmentAddress.zipCode + ' ' + this._shipmentAddress.city;
    return fullAddress;
  }

  get optionLabel(): string {
    let label = this._name + ' - ' + this._shipmentAddress.address + ' ';
    label += this._shipmentAddress.addressLine2 ? this._shipmentAddress.addressLine2 : '';
    label += ', ' + this._shipmentAddress.zipCode + ' ' + this._shipmentAddress.city;
    return label;
  }

  get refNameFullAddress(): string {
    return this._shipmentAddress.refName + ' - ' + this.fullAddress;
  }

  get info(): IExtractInfo {
    return this._extractInfo;
  }

  static fromRaw(partyRaw: any): Party {
    console.log(partyRaw);

    const shipmentAddress = partyRaw.data ?  ShipmentAddress.fromRaw(partyRaw.data.shipment_address) : undefined;
    const name = partyRaw.data ?  partyRaw.data.name : undefined;
    const companyAddress = partyRaw.data ?  Address.fromRawCompany(partyRaw.data.company_address) : undefined;
    const pos =  partyRaw.data ?  Pos.fromRawPos(partyRaw.data.pos) : undefined;
    const iban = partyRaw.data ?  partyRaw.data.iban : undefined;

    const party = new Party(
      partyRaw.entity,
      partyRaw.key,
      shipmentAddress,
      name,
      companyAddress,
      pos,
      iban,
    );

    // Get the lab_id of a shop
    if (partyRaw.entity === 'shop') {
      // console.log('Party.fromRaw [shop]', partyRaw);
      if (partyRaw.data) {
        party._extractInfo.agent_id = partyRaw.data.agent_id;
        party._extractInfo.mshp_id = partyRaw.data.mshp_id;
        if (partyRaw.data.labs && partyRaw.data.labs.length) {
          // console.log('Party.fromRaw [labs]', partyRaw.data.labs[0]);
          party._extractInfo.lab_id = partyRaw.data.labs[0].id;
        }
      }
    }

    return party;
  }

  static fromRawWithoutPos(partyRaw: any): Party {

    const shipmentAddress = partyRaw.data ?  ShipmentAddress.fromRaw(partyRaw.data.shipment_address) : undefined;
    const name = partyRaw.data ?  partyRaw.data.name : undefined;
    const companyAddress = partyRaw.data ?  Address.fromRawCompany(partyRaw.data.company_address) : undefined;
    const iban = partyRaw.data ?  partyRaw.data.iban : undefined;

    return new Party(
      partyRaw.entity,
      partyRaw.key,
      shipmentAddress,
      name,
      companyAddress,
      iban,
    );
  }

  static fromRawShipment(partyRaw: any) {
    return new Party(
      partyRaw.entity,
      partyRaw.key,
      ShipmentAddress.fromRaw(partyRaw.shipment_address),
    );
  }

  toRaw() {
    return {
      key: this._id,
      entity: this._entity,
      shipment_address: this._shipmentAddress.toRaw()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/party.ts